module.exports = __webpack_public_path__ + "img/set-item5.d49b26d1.png";